// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import type { Coverage, ProviderIcons } from '../types'

const CoverageWrapper = styled.div`
  display: flex;
  align-items: bottom;
  gap: 5px;
`

type Props = {|
  icons: ProviderIcons,
  coverage: Array<Coverage>
|}

export default class TargetingSourcesCoverage extends Component<Props> {
  render() {
    const { icons, coverage } = this.props
    return (
      <div>
        {_.map(coverage, (providerCoverage) => {
          return (
            <CoverageWrapper key={`${providerCoverage.provider}_${providerCoverage.note}`}>
              <img src={icons[providerCoverage.provider]} />
              {providerCoverage.note}
            </CoverageWrapper>
          )
        })}
      </div>
    )
  }
}
